import { ToastContainer } from 'react-toastify';
import './App.css';
import RouterComponent from "./router/Router";
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector } from 'react-redux';
import Loading from "./Loader/Loader"
import ScrollToTop from './scroll';


function App() {
  const { isLoading } = useSelector((state) => state.counter);

  // useEffect(() => {
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   const disableDevToolsShortcuts = (event) => {
  //     if (event.keyCode === 123) {
  //       event.preventDefault();
  //     }
  //     if (
  //       (event.ctrlKey && event.shiftKey && event.keyCode === 73) ||
  //       (event.metaKey && event.altKey && event.keyCode === 73)
  //     ) {
  //       event.preventDefault();
  //     }
  //     if (
  //       (event.ctrlKey && event.shiftKey && event.keyCode === 67) ||
  //       (event.metaKey && event.altKey && event.keyCode === 67)
  //     ) {
  //       event.preventDefault();
  //     }
  //     if (
  //       (event.ctrlKey && event.keyCode === 85) ||
  //       (event.metaKey && event.keyCode === 85)
  //     ) {
  //       event.preventDefault();
  //     }
  //   };

  //   const detectDevTools = () => {
  //     let opened = false;
  //     const threshold = 160;
  //     const checkDevTools = () => {
  //       if (
  //         window.outerWidth - window.innerWidth > threshold ||
  //         window.outerHeight - window.innerHeight > threshold
  //       ) {
  //         if (!opened) {
  //           console.log("DevTools opened");
  //         }
  //         opened = true;
  //       } else {
  //         opened = false;
  //       }
  //     };

  //     window.addEventListener("resize", checkDevTools);
  //     return () => {
  //       window.removeEventListener("resize", checkDevTools);
  //     };
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);
  //   window.addEventListener("keydown", disableDevToolsShortcuts);
  //   detectDevTools();

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     window.removeEventListener("keydown", disableDevToolsShortcuts);
  //   };
  // }, []);


  return (
    <div className="App">
      {isLoading && <Loading />}
      <Router>
        <ScrollToTop />
        <ToastContainer />
        <RouterComponent />
      </Router>
    </div>
  );
}

export default App;
